import {createSelector} from 'reselect';

import {getUIState} from '../../../../ui-selectors';

const getSMSState = createSelector([getUIState], (uiState) => uiState.sms);

const getSMSChartState = createSelector([getSMSState], (chat) => chat.timeseriesChart);

export const getCurrentReportChartIsLoading = createSelector(
    [getSMSChartState],
    (timeseriesChartState) => timeseriesChartState.isLoading
);

export const isChartTimedOut = createSelector(
    [getSMSChartState],
    (timeseriesChartState) => timeseriesChartState.isTimedOut
);

export const isChartErrored = createSelector(
    [getSMSChartState],
    (timeseriesChartState) => timeseriesChartState.isErrored
);

export const getCurrentReportChartData = createSelector(
    [getSMSChartState],
    (timeseriesChartState) => timeseriesChartState.chartData
);
